export default "__VITE_ASSET__BtdEZkIg__"